import script from "./FormatDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./FormatDropdown.vue?vue&type=script&setup=true&lang=js"

import "./FormatDropdown.vue?vue&type=style&index=0&id=3538e7d3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3538e7d3"]])

export default __exports__